import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';

export default function PriceAdjustmentControls({ multiplier, disabled, adjusted, finalPrice, onAdjust, onCompare }) {
  const [comparing, setComparing] = useState(false);
  const [target, setTarget] = useState('');
  const [error, setError] = useState('');
  const adjust = value => { setError(''); onAdjust(value); };
  const applyPrice = () => {
    if (disabled) return;
    if (target.trim() === '' || !Number.isFinite(Number(target)) || Number(target) <= 0) {
      setError('Enter a desired sale price greater than zero.');
      return;
    }
    try { onCompare(target); setError(''); setComparing(false); }
    catch (err) { setError(err.message); }
  };
  return <div className="my-3">
    <div className="d-flex flex-wrap gap-2">
      <Button size="sm" disabled={disabled} title="Increase active multiplier by 0.01" onClick={() => adjust(Number((multiplier + 0.01).toFixed(8)))}>PRICE UP</Button>
      <Button size="sm" disabled={disabled || multiplier <= 0.01} title="Decrease active multiplier by 0.01" onClick={() => adjust(Number((multiplier - 0.01).toFixed(8)))}>PRICE DOWN</Button>
      <Button size="sm" disabled={disabled} title="Set multiplier to 1.42 (approximately 5% net margin)" onClick={() => adjust(1.42)}>5%</Button>
      <Button size="sm" disabled={disabled} title="Set multiplier to 1.53 (approximately 10% net margin)" onClick={() => adjust(1.53)}>10%</Button>
      <Button size="sm" disabled={disabled} onClick={() => { setTarget(String(finalPrice ?? '')); setError(''); setComparing(true); }}>COMPARE PRICE</Button>
      <Button size="sm" variant="outline-secondary" disabled={!adjusted} onClick={() => { adjust(null); setComparing(false); }}>RESET PRICE</Button>
    </div>
    <small className="text-muted">Preview only. Adjustments do not change the saved formula. Up/down change the multiplier by 0.01; 5%/10% select the legacy net-margin presets.</small>
    {comparing && <div className="border rounded p-3 mt-2">
      <Form.Group controlId="preview-desired-price"><Form.Label>Desired sale price ($)</Form.Label><Form.Control type="number" min="0.01" step="0.01" value={target} onChange={event => setTarget(event.target.value)} onKeyDown={event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          applyPrice();
        }
      }} /></Form.Group>
      <p className="small mt-2">Apply calculates a preview multiplier to match this price. The formula must be linear in SmallNetMultiplier.</p>
      {error && <Alert variant="danger">{error}</Alert>}
      <Button size="sm" type="button" disabled={disabled} onClick={applyPrice}>Apply price</Button>{' '}
      <Button size="sm" type="button" variant="secondary" onClick={() => { setComparing(false); setError(''); }}>Cancel</Button>
    </div>}
  </div>;
}
